import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ role, allowedRoles }) => {
  // If role is still undefined (loading), return nothing or a loader
  if (role === undefined) {
    return <div>Loading...</div>; // or a spinner
  }
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/handle-meetings" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
